export default "__VITE_PUBLIC_ASSET__3c775456__"